import { CheckCircle as CheckCircle2 } from "@phosphor-icons/react";

/** A facsimile of the Google permission step, so racers know which switch has to
 *  stay on. Not a screenshot, Google's real screen wording shifts, and shipping a
 *  stale screenshot is worse than a clear illustration. */
export const GoogleConsentHint = () => (
  <div
    className="rounded-xl overflow-hidden border mb-4"
    style={{ borderColor: "var(--pr-line)", background: "var(--pr-card)" }}
    data-testid="google-consent-hint"
  >
    <p
      className="text-[10px] font-bold uppercase tracking-widest px-3 py-2"
      style={{ background: "var(--pr-bg)", color: "var(--pr-muted)" }}
    >
      What Google will ask you
    </p>

    <div className="p-3">
      <p className="text-[11px] mb-2" style={{ color: "var(--pr-muted)" }}>
        Payday Relay wants to access your Google Account
      </p>

      <div
        className="rounded-lg border px-3 py-2.5 mb-2"
        style={{ borderColor: "var(--pr-green)", background: "rgba(74,124,89,0.06)" }}
      >
        <div className="flex items-start gap-2.5">
          <div className="w-9 h-5 rounded-full flex items-center shrink-0 mt-0.5" style={{ background: "var(--pr-green)" }}>
            <span className="w-4 h-4 rounded-full bg-white ml-auto mr-0.5" />
          </div>
          <div>
            <p className="text-xs font-bold leading-snug" style={{ color: "var(--pr-ink)" }}>
              See, edit, create and delete all your Google Sheets spreadsheets
            </p>
            <p className="text-[11px] font-bold mt-1 inline-flex items-center gap-1" style={{ color: "var(--pr-green)" }}>
              <CheckCircle2 className="w-3.5 h-3.5" /> Leave this one ON
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border px-3 py-2.5" style={{ borderColor: "var(--pr-line)" }}>
        <div className="flex items-start gap-2.5">
          <div className="w-9 h-5 rounded-full flex items-center shrink-0 mt-0.5" style={{ background: "var(--pr-line)" }}>
            <span className="w-4 h-4 rounded-full bg-white ml-0.5" />
          </div>
          <p className="text-xs leading-snug" style={{ color: "var(--pr-ink2)" }}>
            Your name and email address <span style={{ color: "var(--pr-muted)" }}>, optional</span>
          </p>
        </div>
      </div>

      <p className="text-[11px] mt-2.5 leading-relaxed" style={{ color: "var(--pr-ink2)" }}>
        The spreadsheet switch is the one that builds your sheet. If it's off, Google blocks us and
        the build fails. We never see your files, photos or email.
      </p>
    </div>
  </div>
);
